import React from 'react';
import styles from './MTabs.module.css';

export type MTabsKey = string;

export interface MTabsItem {
  key: MTabsKey;
  label: string;
}

export interface MTabsProps {
  items: MTabsItem[];
  value: MTabsKey;
  onChange: (key: MTabsKey) => void;
  className?: string;
}

const MTabs: React.FC<MTabsProps> = ({ items, value, onChange, className }) => {
  return (
    <div className={`${styles.mtabsContainer} ${className || ''}`}>
      {items.map((item) => {
        const selected = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            className={`${styles.mtab} ${selected ? styles.mtabSelected : ''}`}
            onClick={() => onChange(item.key)}
          >
            <span className={styles.mtabLabel}>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MTabs;
